import React, { useState } from "react";
import ArrowDownIcon from "../../../assets/icons/arrow-down.svg";
import ArrowUpIcon from "../../../assets/icons/arrow-up.svg";
import HowToPlay1 from "../../../assets/images/howToPlay1.svg";
import HowToPlay2 from "../../../assets/images/howToPlay2.svg";
import HowToPlay3 from "../../../assets/images/howToPlay3.svg";
import HowToPlay4 from "../../../assets/images/howToPlay4.svg";
import HowToPlay5 from "../../../assets/images/howToPlay5.svg";

interface HowToPlayModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface DropdownSectionProps {
  title: string;
  number: number;
  imageSrc: string;
  children: React.ReactNode;
}

const DropdownSection: React.FC<DropdownSectionProps> = ({
  title,
  number,
  imageSrc,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={`how-to-play__section ${
        isExpanded ? "how-to-play__section--expanded" : ""
      }`}
    >
      <button
        className="how-to-play__section-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="how-to-play__section-title">
          {number}. {title}
        </span>
        <img
          src={isExpanded ? ArrowUpIcon : ArrowDownIcon}
          alt={isExpanded ? "Collapse" : "Expand"}
          className="how-to-play__arrow-icon"
        />
      </button>
      {isExpanded && (
        <div className="how-to-play__section-content">
          <img
            src={imageSrc}
            alt={`How to play step ${number}`}
            className="how-to-play__section-image"
          />
          {children}
        </div>
      )}
    </div>
  );
};

const HowToPlayModal: React.FC<HowToPlayModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="how-to-play__modal-overlay">
      <div className="how-to-play__modal">
        <div className="how-to-play__modal-header">
          <h3 className="how-to-play__modal-title">How to Play</h3>
          <button className="how-to-play__modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="how-to-play__sections">
          <DropdownSection
            title="Connect Wallet"
            number={1}
            imageSrc={HowToPlay1}
          >
            <p>
              Click the Connect Wallet button on the top right corner. Select
              your desired wallet, and connect to it.
            </p>
            <p>
              More information on how to purchase SUI coins into your wallet
              using fiat currency or other crypto can be found{" "}
              <a href="#" className="how-to-play__link">
                here
              </a>
            </p>
          </DropdownSection>

          <DropdownSection
            title="Pick Heads or Tails on at least one coin"
            number={2}
            imageSrc={HowToPlay2}
          >
            <p>
              In Fourhead, there are four coins with different probabilities:
              Each coin displays the probability of heads and tails, and the
              rewards of selecting the correct choice. Your job is to accurately
              guess which way the coin will land on at least one of the coins.
            </p>
          </DropdownSection>

          <DropdownSection
            title="Place Your Bets"
            number={3}
            imageSrc={HowToPlay3}
          >
            <p>
              Once you've selected heads or tails in each of the coins, place a
              bet on the coin. You can manually enter the amount you want to bet
              or increase/decrease with the up/down arrows in the bet-box.
            </p>
          </DropdownSection>

          <DropdownSection
            title="Flip your coins!"
            number={4}
            imageSrc={HowToPlay4}
          >
            <p>
              Click on the Flip Coin button, approve the transactions, and wait
              for the results. Winning in Fourhead is all about guessing
              correctly! Here's how rewards work:
            </p>
            <ul className="how-to-play__bullet-list">
              <li>
                Balance your risk: Coins with higher odds for heads have smaller
                rewards for heads and larger rewards for tails. Balance safe
                bets with higher-risk ones for bigger rewards.
              </li>
              <li>
                Test your luck with the Snake Bet: This is a high-risk,
                high-reward option. Use it wisely!
              </li>
              <li>
                Start small: If you're new, start with smaller bets until you
                get the hang of the game.
              </li>
              <li>Best of luck!</li>
            </ul>
          </DropdownSection>

          <DropdownSection title="Panther Bet" number={5} imageSrc={HowToPlay5}>
            <p>
              The Panther Bet is a parlay that rewards you if you place a bet
              and all the coins flip to be tails. If this happens, you make 50x
              the amount you bet on the Panther.
            </p>
          </DropdownSection>
        </div>
      </div>
    </div>
  );
};

export default HowToPlayModal;
